export const INVITATIONS_MIN_TABLE_WIDTH = 900;
export const INVITATIONS_MIN_MODAL_WIDTH = INVITATIONS_MIN_TABLE_WIDTH + 48;
export const DELETE_EXTERNAL_INVITATION_CACHE_KAY =
  "delete-external-invitation";

export const INVITATION_CARD_COLUMN_SPANS = [16, 8];
